import { render } from "./Single.vue?vue&type=template&id=5a25750c"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Single.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a25750c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a25750c', __exports__)) {
    api.reload('5a25750c', __exports__)
  }
  
  module.hot.accept("./Single.vue?vue&type=template&id=5a25750c", () => {
    api.rerender('5a25750c', render)
  })

}


export default __exports__